
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35544",
  depVersions: {
  "documents-public-ui": "static-1.35544",
  "atom": "static-1.5551",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2964",
  "client-types": "static-1.511",
  "cssUtils": "static-1.1101",
  "customer-data-filters-ui": "static-1.41379",
  "customer-data-objects": "static-1.8185",
  "customer-data-property-utils": "static-1.8530",
  "documents-lib": "static-1.35549",
  "emoji-mart": "static-3.7",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86844",
  "FormUrlGenerator": "static-2.5192",
  "foundations-theming-specialty": "static-1.2683",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6071",
  "hs-test-utils": "static-1.8517",
  "hub-http": "static-1.6685",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12273",
  "HubStyleTokens": "static-2.11966",
  "I18n": "static-7.1708",
  "icons": "static-2.703",
  "jasmine-immutable": "static-1.3417",
  "jasmine-runner": "static-1.6930",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7625",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3364",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5859",
  "quartz": "static-1.7661",
  "react": "static-7.202",
  "react-dlb": "static-1.93",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17216",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "reference-resolvers": "static-1.8662",
  "reference-resolvers-lite": "static-1.8592",
  "reporting-data": "static-1.69363",
  "reporting-reports": "static-1.69039",
  "reporting-snowflake": "static-1.57979",
  "reporting-testing-lib": "static-1.11296",
  "reporting-visualizations": "static-1.61437",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9440",
  "sanitize": "static-1.4954",
  "sanitize-text": "static-1.8638",
  "SharedI18nStrings": "static-1.187",
  "SharedLegalStrings": "static-1.2208",
  "signup-constants": "static-1.19951",
  "signup-ui-url-generator": "static-2.8520",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5238",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5227",
  "ui-addon-form-validation": "static-1.11348",
  "ui-asset-management-lib": "static-1.11580",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8912",
  "usage-tracker": "static-1.7803",
  "usage-tracker-container": "static-1.7793",
  "usage-tracker-core": "static-1.7653",
  "viral-links-lib": "static-1.7560",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10119",
  "foundations-components": "static-1.8756",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1439",
  "quartz-core": "static-1.6880",
  "quick-fetch": "static-1.4233",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5149",
  "ui-addon-i18n": "static-1.11624",
  "ui-addon-upgrades": "static-9.18548",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3938",
  "quartz-webpack": "static-1.3885",
  "foundations-assets": "static-1.5364",
  "foundations-theming": "static-1.4967",
  "hub-http-janus": "static-1.907",
  "hub-http-shared-msw-handlers": "static-1.10913",
  "hubspotter-http": "static-1.4977",
  "trellis-components": "static-1.3118",
  "trellis-migration-context": "static-1.60",
  "sassPrefix": "static-1.367",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44117",
  "customer-data-filters-ui-msw-helpers": "static-1.23814",
  "customer-data-objects-ui-components": "static-1.13515",
  "customer-data-reference-ui-components": "static-1.13655",
  "customer-data-ui-utilities": "static-1.10311",
  "events-data-lib": "static-1.725",
  "framework-builder-read-service-client": "static-1.4337",
  "hs-resources": "static-1.667",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3776",
  "inbound-db-properties-service-client": "static-1.4153",
  "multi-account-reference-resolvers": "static-1.1489",
  "onboarding-tours": "static-1.17410",
  "pulse": "static-1.1127",
  "reporting-datasets-permissions-lib": "static-1.14779",
  "segments-client-types": "static-1.12165",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.3099",
  "trellis-theming": "static-1.1486",
  "ui-addon-teams": "static-1.22016",
  "quartz-auth": "static-1.1336",
  "ui-business-units-lib": "static-1.9574",
  "usage-tracker-session-replay": "static-1.5489",
  "ai-components-ui-library": "static-1.10029",
  "ContentUtils": "static-1.69483",
  "customer-data-properties": "static-1.53063",
  "forms-ai-lib": "static-1.4991",
  "forms-utils-lib": "static-1.13345",
  "foundations-components-test-utils": "static-1.6239",
  "react-dnd-compat": "static-1.5089",
  "react-tinymce": "static-1.56278",
  "tinymce-config": "static-2.55404",
  "ui-gdpr-components": "static-1.10656",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3952",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3628",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.402",
  "ui-fonts": "static-1.1228",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4786",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.179",
  "quartz-head": "static-1.1326",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.2028",
  "external-options-client-types": "static-1.4441",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1336",
  "frontend-preferences-client": "static-1.8399",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4185",
  "reporting-client-types": "static-1.2840",
  "apollo-stack-hubspot": "static-3.99",
  "hubspot-apollo-client": "static-1.5361",
  "foundations-components-legacy": "static-1.1781",
  "quartz-routing": "static-1.1091",
  "hs-story-utils": "static-1.9906",
  "react-flip-move": "static-1.83",
  "nested-table": "static-1.712",
  "seat-types-lib": "static-1.1062",
  "timezone-utils": "static-2.5709",
  "react-create-root-preference": "static-1.103",
  "bend-plugin-foundations-components": "static-1.5025",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "opentelemetry-fe-types": "static-1.270",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.645",
  "quartz-test": "static-1.1336",
  "quartz-tracking": "static-1.1040",
  "bend-plugin-chirp-manifest": "static-1.559",
  "chirp-fetch": "static-1.2384",
  "merchandise-lib": "static-1.284",
  "purchase-motions-components": "static-1.6637",
  "ts-schema": "static-1.4395",
  "bender-build-tools": "static-1.3600",
  "bend-plugin-foundations-theming": "static-1.3450",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "restore-request-side-panel-lib": "static-1.2035",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5067",
  "conditional-properties-service-client": "static-1.4115",
  "crm-pipelines-api-client-types": "static-1.4445",
  "event-emitter": "static-1.1441",
  "fdsr-migration-layer": "static-1.491",
  "multi-currency-client-types": "static-1.4009",
  "getting-started-shared-tasks": "static-1.19573",
  "growth-data-modal": "static-1.6141",
  "growth-onboarding-confetti": "static-1.3538",
  "growth-onboarding-next-action-utils": "static-1.2993",
  "navigation-components": "static-1.19176",
  "nest": "static-1.714",
  "onboarding-tours-client": "static-1.5625",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-react": "static-3.10758",
  "ui-shepherd-tracker": "static-1.8139",
  "ui-universal-auth": "static-1.9754",
  "user-context": "static-1.5533",
  "bend-plugin-pulse": "static-1.630",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6928",
  "stylex-utils": "static-1.175",
  "hubspotter-http-shared-msw-handlers": "static-1.10911",
  "magpie-lib": "static-1.5910",
  "navigation-messaging": "static-1.8503",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23910",
  "copilot-toolkit": "static-1.12158",
  "cms-field-types": "static-1.5290",
  "content-icons-ui": "static-1.2460",
  "integrations-lib": "static-1.17440",
  "calling-global-api": "static-1.66206",
  "calling-internal-common": "static-1.31805",
  "calling-lifecycle-internal": "static-1.67588",
  "calling-lifecycle-messages": "static-1.59880",
  "commerce-products-lib": "static-1.10927",
  "crm-index-visualization-core": "static-1.4764",
  "crm-links": "static-1.6791",
  "customer-data-properties-shared-msw-handlers": "static-1.10240",
  "file-manager-components": "static-1.24852",
  "formula-editor": "static-1.15019",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1111",
  "object-builder-ui-client": "static-1.50057",
  "pipeline-validation-client-types": "static-1.4283",
  "property-value-citations": "static-1.3677",
  "smart-data-capture-core": "static-1.483",
  "smart-property-lib": "static-1.8669",
  "tiered-pricing": "static-1.2287",
  "topics-actions-lib": "static-1.662",
  "trellis-ext-i18n": "static-1.1396",
  "trial-components-library": "static-1.14384",
  "ui-addon-iframeable": "static-1.9554",
  "zustand": "static-1.89",
  "final-form": "static-1.83",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20563",
  "tinymce-themes": "static-1.57374",
  "data-token-picker": "static-1.17143",
  "hub-http-contrib": "static-1.3512",
  "interframe": "static-3.5221",
  "tinymce-data": "static-1.41489",
  "tinymce-plugins": "static-1.58518",
  "ui-addon-sales-email": "static-1.5681",
  "hubspot-apollo-cache": "static-1.820",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.630",
  "opentelemetry-web": "static-1.22",
  "onboarding-scopes": "static-1.6931",
  "purchase-motions-api": "static-1.6640",
  "onboarding-data-sync-lib": "static-1.2847",
  "growth-onboarding-next-action-components": "static-1.3021",
  "user-context-client": "static-1.4989",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5370",
  "reactive-lib": "static-1.1199",
  "simple-logging-lib": "static-1.3531",
  "custom-vendor-connection-lib": "static-1.318",
  "unified-auth-core-lib": "static-1.1550",
  "getting-started-shared-tasks-store": "static-1.18691",
  "nav-meta": "static-1.30813",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2199",
  "integrations-error-boundary-lib": "static-1.14855",
  "integrations-tracking-lib": "static-1.6100",
  "native-integrations-shared-strings": "static-1.8243",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10849",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31812",
  "shared-worker-versioning": "static-1.11521",
  "calling-usage-tracker": "static-1.7019",
  "customer-data-tracking": "static-1.7350",
  "voice-sms-access-library": "static-1.2461",
  "commerce-permissions": "static-1.1264",
  "growth-payments-core": "static-1.26511",
  "products-iframe-lib": "static-1.8915",
  "products-ui-components-shared-msw-handlers": "static-1.11295",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10996",
  "sales-views-client-types": "static-1.4737",
  "framework-data-schema-resolvers": "static-1.7372",
  "location-customization-utils-lib": "static-1.10430",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4621",
  "poll-commands": "static-1.3957",
  "video-components-external": "static-1.12441",
  "video-data-lib": "static-1.36099",
  "bark-lib": "static-1.17009",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6375",
  "react-codemirror": "static-1.11120",
  "data-agent-kit": "static-1.925",
  "data-agent-test-utils": "static-1.469",
  "data-agent-utils": "static-1.938",
  "feedback-loader": "static-1.30069",
  "fsm": "static-1.4236",
  "policy-lib": "static-1.7283",
  "react-colorpicker": "static-2.10688",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11059",
  "embedded-academy-lib": "static-1.16017",
  "hubs-service-types": "static-1.1748",
  "nudge-client-utils": "static-1.3430",
  "salesImages": "static-1.736",
  "FileManagerLib": "static-1.40492",
  "NamespacedHubStyle": "static-2.9369",
  "FileManagerCore": "static-1.40351",
  "content-assistance-lib": "static-1.8430",
  "layout-dnd-components": "static-1.13237",
  "layout-dnd-utils": "static-1.12212",
  "ui-addon-emoji-picker": "static-1.10343",
  "ui-brand-identity-lib": "static-1.16961",
  "InboxConnectUtils": "static-4.15852",
  "meetings-connect-utils-lib": "static-1.8098",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1177",
  "breeze-engine-core": "static-1.1477",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3492",
  "calling-orchestration-schema": "static-1.37238",
  "ui-addon-opt": "static-4.8889",
  "framework-data-schema-quick-fetch": "static-1.7277",
  "crm-record-cards-service-types": "static-1.3871",
  "content-media-composition-data-lib": "static-1.13607",
  "content-media-compositions": "static-2.17614",
  "media-bridge-lib": "static-1.19650",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16678",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4978",
  "enrichment-settings-lib": "static-1.243",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15478",
  "nudge-custom-function-registry": "static-1.3187",
  "nudge-renderer-utils": "static-1.3506",
  "whisper-core-api": "static-1.7645",
  "audio-components": "static-1.6578",
  "FileManagerImages": "static-1.38003",
  "video-components": "static-1.14443",
  "breeze-artifacts-sdk": "static-1.973",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4994",
  "video-embed": "static-1.36933",
  "ui-addon-video-player": "static-1.9103",
  "ui-coaching-tips": "static-1.29588",
  "ContentData": "static-1.69558",
  "layout-data-lib": "static-1.10537",
  "crm-record-cards-client": "static-1.65",
  "academy-service-client": "static-1.4172",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4876",
  "trellis-ecosystem": "static-1.7856",
  "ui-addon-react-router-dom": "static-1.10003",
  "wootric-nps": "static-1.7298",
  "social-insights-client-types": "static-1.22939",
  "outpost": "static-1.4607",
  "growth-onboarding-feedback-components": "static-1.7059",
  "advanced-menus-core": "static-1.15824",
  "advanced-menus-lib": "static-1.12575",
  "ExportDialog": "static-6.10853",
  "ui-memberships-settings-lib": "static-1.35205",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15823",
  "simple-menus-lib": "static-1.17340",
  "settings-ui-lib": "static-1.13007",
  "developer-experience-shared-components": "static-1.11018",
  "immutable-less": "static-1.5132",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8433",
  "ui-extensibility-client-types": "static-1.4395",
  "ai-settings-ui-library": "static-1.8594",
  "ui-product-approvals-common": "static-1.1590",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4617",
  "simple-data-table": "static-1.3832"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35544",
  "atom": "/atom/static-1.5551",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2964",
  "client-types": "/client-types/static-1.511",
  "cssUtils": "/cssUtils/static-1.1101",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41379",
  "customer-data-objects": "/customer-data-objects/static-1.8185",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8530",
  "documents-lib": "/documents-lib/static-1.35549",
  "emoji-mart": "/emoji-mart/static-3.7",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86844",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5192",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2683",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6071",
  "hs-test-utils": "/hs-test-utils/static-1.8517",
  "hub-http": "/hub-http/static-1.6685",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12273",
  "HubStyleTokens": "/HubStyleTokens/static-2.11966",
  "I18n": "/I18n/static-7.1708",
  "icons": "/icons/static-2.703",
  "jasmine-immutable": "/jasmine-immutable/static-1.3417",
  "jasmine-runner": "/jasmine-runner/static-1.6930",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7625",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3364",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5859",
  "quartz": "/quartz/static-1.7661",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17216",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "reference-resolvers": "/reference-resolvers/static-1.8662",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8592",
  "reporting-data": "/reporting-data/static-1.69363",
  "reporting-reports": "/reporting-reports/static-1.69039",
  "reporting-snowflake": "/reporting-snowflake/static-1.57979",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11296",
  "reporting-visualizations": "/reporting-visualizations/static-1.61437",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9440",
  "sanitize": "/sanitize/static-1.4954",
  "sanitize-text": "/sanitize-text/static-1.8638",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2208",
  "signup-constants": "/signup-constants/static-1.19951",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5238",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5227",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11580",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8912",
  "usage-tracker": "/usage-tracker/static-1.7803",
  "usage-tracker-container": "/usage-tracker-container/static-1.7793",
  "usage-tracker-core": "/usage-tracker-core/static-1.7653",
  "viral-links-lib": "/viral-links-lib/static-1.7560",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10119",
  "foundations-components": "/foundations-components/static-1.8756",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1439",
  "quartz-core": "/quartz-core/static-1.6880",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5149",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11624",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18548",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3938",
  "quartz-webpack": "/quartz-webpack/static-1.3885",
  "foundations-assets": "/foundations-assets/static-1.5364",
  "foundations-theming": "/foundations-theming/static-1.4967",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10913",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "trellis-components": "/trellis-components/static-1.3118",
  "trellis-migration-context": "/trellis-migration-context/static-1.60",
  "sassPrefix": "/sassPrefix/static-1.367",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44117",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23814",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13515",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13655",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10311",
  "events-data-lib": "/events-data-lib/static-1.725",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "hs-resources": "/hs-resources/static-1.667",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1489",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "pulse": "/pulse/static-1.1127",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14779",
  "segments-client-types": "/segments-client-types/static-1.12165",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.3099",
  "trellis-theming": "/trellis-theming/static-1.1486",
  "ui-addon-teams": "/ui-addon-teams/static-1.22016",
  "quartz-auth": "/quartz-auth/static-1.1336",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9574",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5489",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10029",
  "ContentUtils": "/ContentUtils/static-1.69483",
  "customer-data-properties": "/customer-data-properties/static-1.53063",
  "forms-ai-lib": "/forms-ai-lib/static-1.4991",
  "forms-utils-lib": "/forms-utils-lib/static-1.13345",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6239",
  "react-dnd-compat": "/react-dnd-compat/static-1.5089",
  "react-tinymce": "/react-tinymce/static-1.56278",
  "tinymce-config": "/tinymce-config/static-2.55404",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3952",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3628",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "ui-fonts": "/ui-fonts/static-1.1228",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4786",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.179",
  "quartz-head": "/quartz-head/static-1.1326",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.2028",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1336",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8399",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4185",
  "reporting-client-types": "/reporting-client-types/static-1.2840",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5361",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1781",
  "quartz-routing": "/quartz-routing/static-1.1091",
  "hs-story-utils": "/hs-story-utils/static-1.9906",
  "react-flip-move": "/react-flip-move/static-1.83",
  "nested-table": "/nested-table/static-1.712",
  "seat-types-lib": "/seat-types-lib/static-1.1062",
  "timezone-utils": "/timezone-utils/static-2.5709",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5025",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.270",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.645",
  "quartz-test": "/quartz-test/static-1.1336",
  "quartz-tracking": "/quartz-tracking/static-1.1040",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.559",
  "chirp-fetch": "/chirp-fetch/static-1.2384",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "purchase-motions-components": "/purchase-motions-components/static-1.6637",
  "ts-schema": "/ts-schema/static-1.4395",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3450",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2035",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5067",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "event-emitter": "/event-emitter/static-1.1441",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.491",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19573",
  "growth-data-modal": "/growth-data-modal/static-1.6141",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3538",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2993",
  "navigation-components": "/navigation-components/static-1.19176",
  "nest": "/nest/static-1.714",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10758",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8139",
  "ui-universal-auth": "/ui-universal-auth/static-1.9754",
  "user-context": "/user-context/static-1.5533",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.630",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6928",
  "stylex-utils": "/stylex-utils/static-1.175",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10911",
  "magpie-lib": "/magpie-lib/static-1.5910",
  "navigation-messaging": "/navigation-messaging/static-1.8503",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23910",
  "copilot-toolkit": "/copilot-toolkit/static-1.12158",
  "cms-field-types": "/cms-field-types/static-1.5290",
  "content-icons-ui": "/content-icons-ui/static-1.2460",
  "integrations-lib": "/integrations-lib/static-1.17440",
  "calling-global-api": "/calling-global-api/static-1.66206",
  "calling-internal-common": "/calling-internal-common/static-1.31805",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67588",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59880",
  "commerce-products-lib": "/commerce-products-lib/static-1.10927",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4764",
  "crm-links": "/crm-links/static-1.6791",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10240",
  "file-manager-components": "/file-manager-components/static-1.24852",
  "formula-editor": "/formula-editor/static-1.15019",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1111",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50057",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "property-value-citations": "/property-value-citations/static-1.3677",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.483",
  "smart-property-lib": "/smart-property-lib/static-1.8669",
  "tiered-pricing": "/tiered-pricing/static-1.2287",
  "topics-actions-lib": "/topics-actions-lib/static-1.662",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1396",
  "trial-components-library": "/trial-components-library/static-1.14384",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9554",
  "zustand": "/zustand/static-1.89",
  "final-form": "/final-form/static-1.83",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20563",
  "tinymce-themes": "/tinymce-themes/static-1.57374",
  "data-token-picker": "/data-token-picker/static-1.17143",
  "hub-http-contrib": "/hub-http-contrib/static-1.3512",
  "interframe": "/interframe/static-3.5221",
  "tinymce-data": "/tinymce-data/static-1.41489",
  "tinymce-plugins": "/tinymce-plugins/static-1.58518",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5681",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.820",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.630",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "onboarding-scopes": "/onboarding-scopes/static-1.6931",
  "purchase-motions-api": "/purchase-motions-api/static-1.6640",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2847",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3021",
  "user-context-client": "/user-context-client/static-1.4989",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5370",
  "reactive-lib": "/reactive-lib/static-1.1199",
  "simple-logging-lib": "/simple-logging-lib/static-1.3531",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.318",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1550",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18691",
  "nav-meta": "/nav-meta/static-1.30813",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2199",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14855",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6100",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8243",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10849",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31812",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11521",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7019",
  "customer-data-tracking": "/customer-data-tracking/static-1.7350",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2461",
  "commerce-permissions": "/commerce-permissions/static-1.1264",
  "growth-payments-core": "/growth-payments-core/static-1.26511",
  "products-iframe-lib": "/products-iframe-lib/static-1.8915",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11295",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10996",
  "sales-views-client-types": "/sales-views-client-types/static-1.4737",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7372",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10430",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4621",
  "poll-commands": "/poll-commands/static-1.3957",
  "video-components-external": "/video-components-external/static-1.12441",
  "video-data-lib": "/video-data-lib/static-1.36099",
  "bark-lib": "/bark-lib/static-1.17009",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6375",
  "react-codemirror": "/react-codemirror/static-1.11120",
  "data-agent-kit": "/data-agent-kit/static-1.925",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.469",
  "data-agent-utils": "/data-agent-utils/static-1.938",
  "feedback-loader": "/feedback-loader/static-1.30069",
  "fsm": "/fsm/static-1.4236",
  "policy-lib": "/policy-lib/static-1.7283",
  "react-colorpicker": "/react-colorpicker/static-2.10688",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11059",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16017",
  "hubs-service-types": "/hubs-service-types/static-1.1748",
  "nudge-client-utils": "/nudge-client-utils/static-1.3430",
  "salesImages": "/salesImages/static-1.736",
  "FileManagerLib": "/FileManagerLib/static-1.40492",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "FileManagerCore": "/FileManagerCore/static-1.40351",
  "content-assistance-lib": "/content-assistance-lib/static-1.8430",
  "layout-dnd-components": "/layout-dnd-components/static-1.13237",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12212",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10343",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16961",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15852",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8098",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1177",
  "breeze-engine-core": "/breeze-engine-core/static-1.1477",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3492",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37238",
  "ui-addon-opt": "/ui-addon-opt/static-4.8889",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7277",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13607",
  "content-media-compositions": "/content-media-compositions/static-2.17614",
  "media-bridge-lib": "/media-bridge-lib/static-1.19650",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16678",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4978",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.243",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15478",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3187",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3506",
  "whisper-core-api": "/whisper-core-api/static-1.7645",
  "audio-components": "/audio-components/static-1.6578",
  "FileManagerImages": "/FileManagerImages/static-1.38003",
  "video-components": "/video-components/static-1.14443",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.973",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4994",
  "video-embed": "/video-embed/static-1.36933",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9103",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29588",
  "ContentData": "/ContentData/static-1.69558",
  "layout-data-lib": "/layout-data-lib/static-1.10537",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.65",
  "academy-service-client": "/academy-service-client/static-1.4172",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4876",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7856",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10003",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "social-insights-client-types": "/social-insights-client-types/static-1.22939",
  "outpost": "/outpost/static-1.4607",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7059",
  "advanced-menus-core": "/advanced-menus-core/static-1.15824",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12575",
  "ExportDialog": "/ExportDialog/static-6.10853",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35205",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15823",
  "simple-menus-lib": "/simple-menus-lib/static-1.17340",
  "settings-ui-lib": "/settings-ui-lib/static-1.13007",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11018",
  "immutable-less": "/immutable-less/static-1.5132",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8433",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4395",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8594",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1590",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4617",
  "simple-data-table": "/simple-data-table/static-1.3832"
}
};
